module.exports = __webpack_public_path__ + "0d1336f100a47ef92646886a1f8d1aa1.png";